<script setup lang="ts">
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            active?: boolean | number | null;
            status?: 'active' | 'inactive' | 'deleted';
            type?: 'yesNo' | 'activeInactive' | 'companyStatus' | 'invoiceStatus';
        }>(),
        {
            type: 'activeInactive',
        },
    );

    const statusText = computed(() => {
        if (props.type === 'companyStatus' && props.status) {
            switch (props.status) {
                case 'active':
                    return 'translations.status.active';
                case 'inactive':
                    return 'translations.status.inactive';
                case 'deleted':
                    return 'translations.deleted';
                default:
                    return 'translations.status.inactive';
            }
        }

        if (props.type === 'yesNo') {
            return props.active ? 'forms.yes' : 'forms.no';
        }

        if (props.type === 'invoiceStatus') {
            return props.active ? 'translations.status.paid' : 'translations.status.unpaid';
        }

        return props.active ? 'translations.status.active' : 'translations.status.inactive';
    });

    const statusColor = computed(() => {
        if (props.type === 'companyStatus' && props.status) {
            switch (props.status) {
                case 'active':
                    return 'bg-accent';
                case 'inactive':
                case 'deleted':
                    return 'bg-destructive';
                default:
                    return 'bg-destructive';
            }
        }

        return props.active ? 'bg-accent' : 'bg-destructive';
    });
</script>

<template>
    <div class="flex items-center gap-1.5">
        <span
            class="size-3 rounded-full"
            :class="statusColor"
        />
        <span>
            {{ $t(statusText) }}
        </span>
    </div>
</template>
